interface Ushe {
  id: number;
  name: string;
}

export const usheList: Ushe[] = [
  { id: 230676, name: 'Uintah Basin Technical College' },
  { id: 230737, name: 'Utah Valley University' },
  { id: 230171, name: 'Utah Tech University' },
  { id: 230746, name: 'Salt Lake Community College' },
  { id: 451583, name: 'Dixie Technical College' },
  { id: 230597, name: 'Snow College' },
  { id: 230162, name: 'Davis Technical College' },
  { id: 230010, name: 'Bridgerland Technical College' },
  { id: 448248, name: 'Mountainland Technical College' },
  { id: 449816, name: 'Southwest Technical College' },
  { id: 230728, name: 'Utah State University' },
  { id: 230603, name: 'Southern Utah University' },
  { id: 475723, name: 'Tooele Technical College' },
  { id: 230490, name: 'Ogden-Weber Technical College' },
  { id: 230782, name: 'Weber State University' },
  { id: 230764, name: 'University of Utah' },
];
// { id: 230092, name: 'Utah State University Eastern' } not in ipeds collection, not in hd2025 from IPEDS

export const usheIds = usheList.map((u) => u.id);
